import useEntity from "../../hooks/useScopeGroup";
import ScopeGroupDetail from "../../components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail";
import ScopeGroupScoped from "../../components/scopeGroup/ScopeGroupDetail/ScopeGroupScoped";
import ScopeGroupTabs from "../../components/scopeGroup/ScopeGroupDetail/ScopeGroupTabs";
import { useGetScopeGroupQuery } from "../../apis/ScopeGroup.api";
import { PrimaryScopeGroup } from "../../types/models/ScopeGroup";
import React from "react";
import {Assignment, AssignmentAdd, AssignmentReturn, Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import useAuth, {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ScopeGroupDetailPage = () => {

    useTitle(t`Details Scope Group`);

    const { session, handleRefresh, refreshLoading } = useAuth()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { scopeGroupId: id } = useParams();

    const { data, refetch } = useGetScopeGroupQuery(PrimaryScopeGroup.fromPath(id))

    const selectedScopeGroupId = session?.scopeGroupContext?.group;

    const { deleteScopeGroup } = useEntity();

    const onAssign = React.useCallback(async () => {
        await handleRefresh(data.id)
    }, [data])

    const onResetAssign = React.useCallback(async () => {
        await handleRefresh(undefined, true)
    })

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteScopeGroup(data, '..')
    }, [data, deleteScopeGroup])

    if (id === 'scoped') {
        return (<ScopeGroupScoped/>)
    }

    return (
        <Box data-testid="ScopeGroup-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ScopeGroupDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/ScopeGroups/update/view') &&
                        <Button size="small" variant="outlined" data-testid="ScopeGroup-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    {
                        session.hasPermission('', 'applications/auth/entities/ScopeGroups/assign/view') &&
                        (
                            selectedScopeGroupId === data.id ?
                                <Button size="small" variant="outlined" data-testid="ScopeGroup-edit-button" startIcon={<AssignmentReturn/>}
                                        onClick={onResetAssign}
                                        loading={refreshLoading}
                                >
                                    <Trans>Reset Assign</Trans>
                                </Button>
                            :
                                <Button size="small" variant="outlined" data-testid="ScopeGroup-edit-button" startIcon={<AssignmentAdd/>}
                                        onClick={onAssign}
                                        loading={refreshLoading}
                                >
                                    <Trans>Assign</Trans>
                                </Button>
                        )
                    }
                    { 
        session.hasPermission('', 'applications/auth/entities/ScopeGroups/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="ScopeGroup-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ScopeGroupTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ScopeGroupDetailPage;
